<template>
  <div class="selected-meida">
    <div class="selected-meida-img" @click="isHidden=!isHidden">
      <img v-if="selectMedia=='facebook'" src="../../assets/icon/facebook.svg" alt="facebook" />
      <img v-if="selectMedia=='twitter'" src="../../assets/icon/twitter-lg.svg" alt="twitter" />
      <img v-if="selectMedia=='instagram'" src="../../assets/icon/instagram-lg.svg" alt="instagram" />
      <img v-if="selectMedia=='snapchat'" src="../../assets/icon/snapchat.svg" alt="snapchat" />
    </div>
    <ul :class="{ 'showDropDown' : isHidden}">
        <li @click="selectedMedia('facebook')">
            <div>
                <img src="../../assets/icon/facebook-sm.svg" alt="facebook" />
            </div>
            <span>Facebook</span>
        </li>
        <li @click="selectedMedia('instagram')">
            <div>
                <img src="../../assets/icon/instagram-sm.svg" alt="Instagram" />
            </div>
            <span>Instagram</span>
        </li>
        <li @click="selectedMedia('twitter')">
            <div>
                <img src="../../assets/icon/twitter-sm.svg" alt="twitter" />
            </div>
            <span>Twitter</span>
        </li>
        <li @click="selectedMedia('snapchat')">
            <div>
                <img src="../../assets/icon/snapchat-sm.svg" alt="snapchat" />
            </div>
            <span>Snapchat</span>
        </li>
    </ul>
  </div>
</template>


<script>


export default {
  name: "social-media-select",
  props: ['media'],

  data(){
    return{
      isHidden:false,
      selectMedia:this.media
      
    }
  },

  methods:{

    /*
    * Push Media
    */
    selectedMedia(data) {
       this.selectMedia=data;
       this.isHidden=false;
    },

  }
  
}

</script>